import styled from 'styled-components';

export const HiddenCheckboxV2 = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  opacity: 0;
`;

export const CheckboxContainerV2 = styled.div`
  display: inline-block;
  vertical-align: middle;
  max-width: 16px;
  height: 16px;
  > svg {
    box-shadow: 0px 0px 3px ${(p) => (p.focused ? 'rgb(3, 0, 165)' : 'transparent')};
  }
`;
